export enum NoticeDestiny {
  client = 'client',
  user = 'user',
  allClients = 'allClients',
  allUsers = 'allUsers'
}
